import styled from 'styled-components'
import ColorConfig from '../../config/ColorConfig'

const IndexContentContainer = styled.a.attrs<{
    height?: number
    isNotHover?: boolean
    backgroundColorType?: 'card' | 'card-card'
    marginBottom?: number
}>({
	className: 'clickable',
})`
	display: flex;
	flex-direction: row;

	position: relative;

	gap: 20px;
	padding: 20px;
	border-radius: 16px;
	background-color: ${props => props.backgroundColorType == 'card-card' ? 'var(--card-card-bg-color)' : 'var(--card-bg-color)'};
	border: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
	height: ${props => props.height}px;
	margin-bottom: ${props => props.marginBottom ?? 20}px;

	&:hover {
		color: ${props => (props.isNotHover ? 'var(--text-color)' : ColorConfig.Primary)};
	}

	color: var(--text-color);
`

export default IndexContentContainer
